var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ checked : _vm.cd.checked, free : _vm.cd.free },on:{"click":function($event){return _vm.$emit('check')}}},[_c('p',[_vm._v(_vm._s(_vm.cd.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }